"use client";

import React from "react";
import GSTR1ASimulation from "../../components/GSTR1ASimulation";

export default function GSTR1APage() {
  return (
    <div>
      <GSTR1ASimulation />
    </div>
  );
}
